<template>
  <div
    class="job-history-item px-3 py-3 d-flex justify-content-between mb-3"
    @click="onClickItem"
  >
    <div class="info">
      <h4 class="id mb-1"># {{ history.job_order_no | job-no }}</h4>
      <div class="detail">
        <!-- <strong>{{ history.inform || '-' }}</strong>
        <span>{{ $t('feature.homecare.inform_list') }}</span>
        <strong>{{ history.fixing || '-' }}</strong>
        <span>{{ $t('feature.homecare.fixing_list') }}</span> -->
      </div>
    </div>
    <div class="text-end">
      <div class="date">{{ history.created_at | moment }}</div>
      <div :class="[history.status]" class="status homecare-status">
        {{ $t("feature.homecare.status." + history.status) }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    history: {
      type: null,
      required: true,
    },
  },
  methods: {
    onClickItem() {
      this.$emit("go", this.history)
    },
  },
}
</script>

<style lang="scss" scoped>
.job-history-item {
  cursor: pointer;
  border: solid 1px #f4f4f2;
  border-radius: 15px;
}
.info {
  min-width: 260px;
  margin-right: 30px;
}
.id {
  color: #4a4a4a;
  font-size: 14px;
  font-weight: bold;
}
.detail {
  font-size: 11px;
  font-weight: 500;
  color: #4a4a4a;
}
.date {
  font-size: 11px;
  font-weight: 500;
  color: #757575;
}
.status {
  font-size: 14px;
  font-weight: bold;
}
</style>
